export default "__VITE_ASSET__DNCHV85b__"